import Link from 'next/link';

import { useMediaQuery, Grid, Button } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

import { Image, LearnMoreLink } from '@/src/components/atoms';
import { SectionHeader } from '@/src/components/molecules';

const useStyles = makeStyles(theme => ({
  listGrid: {
    overflow: 'hidden',
    marginBottom: theme.spacing(3),
    '&:last-child': {
      marginBottom: theme.spacing(0),
    },
  },
  image: {
    maxWidth: 400,
  },
}));

const Features = props => {
  const { data, className, ...rest } = props;

  const classes = useStyles();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), { defaultMatches: true });

  return (
    <div className={className} data-aos="fade-up" {...rest}>
      <SectionHeader
        title="Ecossistema integrado"
        subtitle="Saiba por que nossa plataforma é a melhor solução para venda online 
        para empresas educacionais, sejam elas instituições de ensino ou fornecedoras de 
        produtos e serviços educacionais."
      />
      <Grid container justifyContent="center">
        {data.map((item, index) => (
          <Grid
            data-aos="fade-up"
            key={index.toString()}
            item
            container
            xs={12}
            spacing={isMd ? 4 : 2}
            direction={index % 2 === 1 ? 'row-reverse' : 'row'}
            className={classes.listGrid}>
            <Grid item xs={12} sm={6}>
              <SectionHeader
                titleVariant="h5"
                title={item.title}
                subtitle={item.description}
                ctaGroup={[
                  <Link href={item.href} passHref key="learnMoreCta">
                    <LearnMoreLink title="Saiba mais" variant="h6" />
                  </Link>,
                ]}
                align="left"
                disableGutter
              />
            </Grid>
            <Grid item container justifyContent="center" xs={12} sm={6}>
              <Image
                src={item.illustration}
                alt={item.title}
                width="100%"
                className={classes.image}
                lazy
              />
            </Grid>
          </Grid>
        ))}
        <Grid item container justifyContent="center" xs={12}>
          <Link href="/schedule?utm_campaign=solutions&utm_content=features" passHref>
            <Button
              component="a"
              color="primary"
              variant="contained"
              size="large"
              aria-label="Agendar demonstração">
              Agendar demonstração
            </Button>
          </Link>
        </Grid>
      </Grid>
    </div>
  );
};

Features.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * data to be rendered
   */
  data: PropTypes.array.isRequired,
};

export default Features;
